import { Trans } from '@lingui/macro';
import { Loader, MenuItem } from '@pocketlaw/tetris';
import { useDownloadFilesystemDocument } from 'app/domains/filesystem/hooks/useDownloadFilesystemDocument';
export function FileDownloads(props) {
    const { id } = props;
    const { files, loading, error } = useDownloadFilesystemDocument(id);
    if (error)
        return null;
    if (!files.length && loading)
        return (<MenuItem disabled>
        <Trans comment="File System Table Row Context Menu - Download file dropdown label">
          Download options
        </Trans>
        <Loader />
      </MenuItem>);
    return files === null || files === void 0 ? void 0 : files.map(file => (<MenuItem disabled={loading} as="button" key={file.type} onClick={() => {
            file.fetch();
        }}>
      <Trans comment="File System Table Row Context Menu - Download file dropdown label">
        Download {file.name}
      </Trans>
    </MenuItem>));
}
